import BILLING_API from 'api/billing/v1'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import { REFUND_CREATE } from 'modules/Services/types'

function* createRefund({
  payload,
  formName,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))
    const { error } = yield call(BILLING_API.createRefund, {
      ...payload,
    })

    if (error) {
      throw error
    }

    yield put(stopSubmit(formName))

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(REFUND_CREATE, createRefund)
}
